/* eslint-disable */

import moment from 'moment';

const INITIAL_STATE = {
  currentCertificate: {
    assetId: 0,
    powerInW: 10,
  },
  filterText: '',
  filterShText: '',
  filterSpText: '',
  filterDateText: '',
  filterProductText: '',
  startDate: moment("2018-01-01", "YYYY-MM-DD").toDate(),
  equivalentCardsStartDate: moment("2018-01-01", "YYYY-MM-DD").toDate(),
  endDate: moment().toDate(),
  equivalentCardsEndDate: moment().toDate(),
  transportCertificates: [],
  transportCertificatesComplete: [],
  error: { message : '', isVisible: false },
  loading: false,
  order: 'asc',
  orderBy: 'id',
  selected: [],
  page: 0,
  rowsPerPage: 10,
  showFilter: false,
  dialogStartDateOpen: false,
  dialogEndDateOpen: false,
};

const transportCertificatesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    //Certificates CRUD

    //Certificates data changing

    case 'TRANSPORT_CERTIFICATES_FILTER_CHANGED':

      const filterText = action.payload;

      const transportCertificates = state.transportCertificatesComplete.filter(function(delivery){
        return (
          delivery["Produit"].toLowerCase().indexOf(state.filterProductText.toLowerCase()) > -1 &&
          delivery["Bon de livraison"].toLowerCase().indexOf(filterText.toLowerCase()) > -1 &&
          (
            delivery["curstomerSiteId"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1 ||
            delivery["curstomerSiteName"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1
          ) &&
          (
            delivery["curstomerId"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1 ||
            delivery["curstomerName"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1
          ) &&
          moment(delivery.date, "DD/MM/YYYY").toDate() >= state.startDate &&
          moment(delivery.date, "DD/MM/YYYY").toDate() <= state.endDate
        );
      })
      return {
        ...state,
        filterText,
        transportCertificates
      }

    case 'TRANSPORT_CERTIFICATES_DATEFILTER_CHANGED':

      const filterDateText = action.payload;

      const transportDateCertificates = state.transportCertificatesComplete.filter(function(delivery){
        return (
          delivery.date.toLowerCase().indexOf(filterDateText.toLowerCase()) > -1
        );
      })
      return {
        ...state,
        filterDateText,
        transportCertificates: transportDateCertificates
      }


    case 'TRANSPORT_CERTIFICATES_PRODUCTFILTER_CHANGED':

      const filterProductText = action.payload;

      const transportProductCertificates = state.transportCertificatesComplete.filter(function(delivery){
        return (
          delivery["Produit"].toLowerCase().indexOf(filterProductText.toLowerCase()) > -1 &&
          delivery["Bon de livraison"].toLowerCase().indexOf(state.filterText.toLowerCase()) > -1 &&
          (
            delivery["curstomerSiteId"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1 ||
            delivery["curstomerSiteName"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1
          ) &&
          (
            delivery["curstomerId"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1 ||
            delivery["curstomerName"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1
          ) &&
          moment(delivery.date, "DD/MM/YYYY").toDate() >= state.startDate &&
          moment(delivery.date, "DD/MM/YYYY").toDate() <= state.endDate
        );
      })
      return {
        ...state,
        filterProductText,
        transportCertificates: transportProductCertificates
      }

    case 'TRANSPORT_CERTIFICATES_SHFILTER_CHANGED':

      const filterShText = action.payload;


      const transportShCertificates = state.transportCertificatesComplete.filter(function(delivery){
        return (
          delivery["Produit"].toLowerCase().indexOf(state.filterProductText.toLowerCase()) > -1 &&
          delivery["Bon de livraison"].toLowerCase().indexOf(state.filterText.toLowerCase()) > -1 &&
          (
            delivery["curstomerSiteId"].toLowerCase().indexOf(filterShText.toLowerCase()) > -1 ||
            delivery["curstomerSiteName"].toLowerCase().indexOf(filterShText.toLowerCase()) > -1
          ) &&
          (
            delivery["curstomerId"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1 ||
            delivery["curstomerName"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1
          ) &&
          moment(delivery.date, "DD/MM/YYYY").toDate() >= state.startDate &&
          moment(delivery.date, "DD/MM/YYYY").toDate() <= state.endDate
        );
      })
      return {
        ...state,
        filterShText,
        transportCertificates: transportShCertificates
      }


    case 'TRANSPORT_CERTIFICATES_SPFILTER_CHANGED':

      const filterSpText = action.payload;

      const transportSpCertificates = state.transportCertificatesComplete.filter(function(delivery){
        return (
          delivery["Produit"].toLowerCase().indexOf(state.filterProductText.toLowerCase()) > -1 &&
          delivery["Bon de livraison"].toLowerCase().indexOf(state.filterText.toLowerCase()) > -1 &&
          (
            delivery["curstomerSiteId"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1 ||
            delivery["curstomerSiteName"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1
          ) &&
          (
            delivery["curstomerId"].toLowerCase().indexOf(filterSpText.toLowerCase()) > -1 ||
            delivery["curstomerName"].toLowerCase().indexOf(filterSpText.toLowerCase()) > -1
          ) &&
          moment(delivery.date, "DD/MM/YYYY").toDate() >= state.startDate &&
          moment(delivery.date, "DD/MM/YYYY").toDate() <= state.endDate
        );
      })
      return {
        ...state,
        filterSpText,
        transportCertificates: transportSpCertificates
      }
    //Getting certificates
    case 'GET_TRANSPORT_CERTIFICATES_START':

      return { ...state,  loading: true }
    case 'GET_TRANSPORT_CERTIFICATES_SUCCESS':

      return { ...state,  transportCertificates: action.payload, transportCertificatesComplete: action.payload, loading: false }
    case 'GET_TRANSPORT_CERTIFICATES_FAIL':

      return { ...state,  loading: false }
    case 'SORT_TRANSPORT_CERTIFICATES':

      const transportCertificatesSort = action.payload.transportCertificates;
      const order = action.payload.order;
      const orderBy = action.payload.orderBy;
      return { ...state, transportCertificates: transportCertificatesSort, order, orderBy }
    case 'CHANGE_PAGE_TRANSPORT_CERTIFICATES':

      const page = action.payload.page;
      return { ...state, page }
    case 'CHANGE_ROWS_PER_PAGE_TRANSPORT_CERTIFICATES':

      const rowsPerPage = action.payload.rowsPerPage;
      return { ...state, rowsPerPage }
    case 'TOGGLE_FILTER_TRANSPORT_CERTIFICATES':

      const showFilter = !state.showFilter;
      return { ...state, showFilter }
    case 'TOGGLE_STARTDATE_TRANSPORT_CERTIFICATES':

      const dialogStartDateOpen = !state.dialogStartDateOpen;
      return { ...state, dialogStartDateOpen }
    case 'TOGGLE_ENDDATE_TRANSPORT_CERTIFICATES':

      const dialogEndDateOpen = !state.dialogEndDateOpen;
      return { ...state, dialogEndDateOpen }

    case 'SET_CARDS_STARTDATE':
        const equivalentCardsStartDate = action.payload;
        return { ...state, equivalentCardsStartDate }
    
    case 'SET_CARDS_ENDDATE':
        const equivalentCardsEndDate = action.payload;
        return { ...state, equivalentCardsEndDate }

    case 'SET_STARTDATE_TRANSPORT_CERTIFICATES':

      const startDate = action.payload;

      const transportStartDateCertificates = state.transportCertificatesComplete.filter(function(delivery){

        return (
          delivery["Produit"].toLowerCase().indexOf(state.filterProductText.toLowerCase()) > -1 &&
          delivery["Bon de livraison"].toLowerCase().indexOf(state.filterText.toLowerCase()) > -1 &&
          (
            delivery["curstomerSiteId"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1 ||
            delivery["curstomerSiteName"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1
          ) &&
          (
            delivery["curstomerId"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1 ||
            delivery["curstomerName"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1
          ) &&
          moment(delivery.date, "DD/MM/YYYY").toDate() >= startDate &&
          moment(delivery.date, "DD/MM/YYYY").toDate() <= state.endDate
        );
      })

      return { ...state, startDate, transportCertificates: transportStartDateCertificates }

            
    case 'SET_ENDDATE_TRANSPORT_CERTIFICATES':

      const endDate = action.payload;

      const transportEndDateCertificates = state.transportCertificatesComplete.filter(function(delivery){

        return (
          delivery["Produit"].toLowerCase().indexOf(state.filterProductText.toLowerCase()) > -1 &&
          delivery["Bon de livraison"].toLowerCase().indexOf(state.filterText.toLowerCase()) > -1 &&
          (
            delivery["curstomerSiteId"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1 ||
            delivery["curstomerSiteName"].toLowerCase().indexOf(state.filterShText.toLowerCase()) > -1
          ) &&
          (
            delivery["curstomerId"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1 ||
            delivery["curstomerName"].toLowerCase().indexOf(state.filterSpText.toLowerCase()) > -1
          ) &&
          moment(delivery.date, "DD/MM/YYYY").toDate() >= state.startDate &&
          moment(delivery.date, "DD/MM/YYYY").toDate() <= endDate
        );
      })
      return { ...state, endDate, transportCertificates: transportEndDateCertificates }


    case 'LOGOUT_SUCCESS':

      return INITIAL_STATE

    default:
      return state
  }
}

export default transportCertificatesReducer



// WEBPACK FOOTER //
// ./src/reducers/transportCertificatesReducer.js